import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { getDefaultOrientation } from "../../lib/layout";
import metaActions from "../../state/meta/actions";
import store from "../../store";

class OrientationSelector extends PureComponent {
	static propTypes = {
		selectedOrientation: PropTypes.string
	};

	setOrientation(orientation) {
		store.dispatch(metaActions.update({ orientation, highlight: null }));
	}

	handleSelection = (evt) => {
		this.setOrientation(evt.target.value);
	}

	render() {
		let { selectedOrientation = getDefaultOrientation() } = this.props;

		return (
			<select
				defaultValue={selectedOrientation}
				onChange={this.handleSelection}>
				<option value="ltr" key="ltr">Left to right</option>
				<option value="rtl" key="rtl">Right to left</option>
				<option value="ttb" key="ttb">Top to bottom</option>
				<option value="btt" key="btt">Bottom to top</option>
			</select>
		);
	}
}

export default OrientationSelector;
